import { render, staticRenderFns } from "./ImportHistoryDetailModal.vue?vue&type=template&id=b5838b5c"
import script from "./ImportHistoryDetailModal.vue?vue&type=script&lang=js"
export * from "./ImportHistoryDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports